import { useSkipOnboarding } from '@/viewmodel/features/onboarding/hooks/useSkipOnboarding';
import type { SkipOnboardingViewState } from '@/viewmodel/features/onboarding/types';

export function useSkipOnboardingViewModel(onSkipped: () => void): SkipOnboardingViewState {
  const { skipOnboarding, isLoading } = useSkipOnboarding();

  const confirm = async (): Promise<void> => {
    if (await skipOnboarding()) onSkipped();
  };

  return { confirm, isSkipping: isLoading };
}
